import {EntityData, field, identifier, SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector, Input} from "@angular/core";
import {CourseReferenceData} from "../course-definition/course-definition.data";

export class CourseSearchData extends EntityData<CourseSearchData> {
    @identifier courseId: number;
    @field courseDefinitionName: string;
    @field idx: number;
    @field name: string;
}

@Injectable()
export class CourseSearchModel extends SearchModel<CourseSearchData> {

    constructor(injector: Injector) {
        super(injector, CourseSearchData);
    }

    override getIdentifierField(): string {
        return "courseId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
